export default "__VITE_ASSET__BeVz5Zd4__"